module.exports = __webpack_public_path__ + "static/img/title2.8843545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title2.png
// module id = b7c6
// module chunks = 26